var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgNoDataPrimaryCheckingAccount = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 119,
    height: 119,
    viewBox: "0 0 119 119",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_29692_56960)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.0991 31.9121H86.9468C87.472 31.9122 87.988 32.0557 88.4468 32.3154C89.3998 32.8549 91.1227 33.7863 92.4565 34.2627C93.2637 34.551 94.2795 34.7988 95.2046 34.9912C96.6258 35.2869 97.6919 36.5106 97.6919 37.9551V104.219C97.6916 105.82 96.3937 107.118 94.7925 107.118H30.0991C28.4977 107.118 27.199 105.82 27.1987 104.219V34.8125C27.1987 33.2109 28.4975 31.9121 30.0991 31.9121Z",
    fill: "#EBF3FE",
    stroke: "#7BABF5",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48.4998,
    y: 41.25,
    width: 35,
    height: 6,
    rx: 3,
    fill: "#3576DA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48.4998,
    y: 56.25,
    width: 35,
    height: 6,
    rx: 3,
    fill: "#3576DA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48.4998,
    y: 72.25,
    width: 35,
    height: 6,
    rx: 3,
    fill: "#101010",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48.4998,
    y: 72.25,
    width: 14,
    height: 6,
    rx: 3,
    fill: "#46F7B7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48.4998,
    y: 87.25,
    width: 35,
    height: 6,
    rx: 3,
    fill: "#101010",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.8769 41.2584C38.7557 40.8548 40.6085 42.0418 41.0272 43.9173C41.4458 45.7929 40.2737 47.655 38.4016 48.0887C36.5082 48.5273 34.6201 47.3389 34.1967 45.442C33.7732 43.5452 34.9767 41.6667 36.8769 41.2584Z",
    fill: "#3576DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.147 69.9014C39.9074 69.6424 42.3587 71.661 42.6333 74.4199C42.9078 77.1788 40.9024 79.6416 38.145 79.9316C35.3657 80.2237 32.8785 78.1989 32.6021 75.418C32.3254 72.637 34.3647 70.1625 37.147 69.9014Z",
    fill: "white",
    stroke: "#46F7B7",
    strokeWidth: 1.6334
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3332 71.8846C39.0019 71.7281 40.4836 72.9486 40.6494 74.6164C40.8154 76.284 39.6031 77.7725 37.9362 77.9478C36.2563 78.1243 34.7533 76.9003 34.5862 75.2194C34.419 73.5384 35.6514 72.0424 37.3332 71.8846Z",
    fill: "#C0BACA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.2476 56.2342C39.1303 56.0366 40.8282 57.3738 41.0774 59.2503C41.3267 61.1269 40.0369 62.8609 38.1679 63.1616C36.9123 63.3637 35.646 62.868 34.8614 61.867C34.0769 60.8662 33.8978 59.5182 34.3938 58.3471C34.8899 57.1761 35.9829 56.3669 37.2476 56.2342Z",
    fill: "#3576DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.0991 30.6328H86.599C83.9772 27.2559 83.0444 25.2012 82.4752 21.2071H30.0991C28.4423 21.2071 27.0991 22.5502 27.0991 24.2071V30.6328Z",
    fill: "#6C7DE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3611 87.002C38.8683 86.8608 40.2064 87.9634 40.3562 89.4697C40.5061 90.9761 39.4107 92.3212 37.905 92.4795C36.3878 92.6387 35.0307 91.5327 34.8796 90.0146C34.7286 88.4962 35.8419 87.1445 37.3611 87.002Z",
    fill: "#101010",
    fillOpacity: 0.2,
    stroke: "#C0BACA",
    strokeWidth: 0.589108
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.4444 6.34554C103.086 5.22071 110.182 10.5348 111.252 18.1842C112.322 25.8337 106.957 32.8911 99.3006 33.9068C91.7206 34.9123 84.7494 29.6132 83.6899 22.0406C82.6303 14.4679 87.8795 7.45909 95.4444 6.34554Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.2028 11.1914V21.5412C97.2028 21.6879 97.0968 21.813 96.9522 21.8371L90.1335 22.9736",
    stroke: "#6C7DE5",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.0586 60.3029L108.336 54.8586L100.687 67.3003L110.874 75.9195L109.796 78.6216L97.7933 75.3652L110.263 104.554L108.85 107.008L105.952 107.784L94.1468 77.3017L87.8204 86.9778L87.1053 72.4653L73.0819 68.6594L74.6282 66.22L86.664 63.4945L85.9489 48.982L87.456 46.4793L95.0586 60.3029Z",
    fill: "#E7DFF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.4721 57.8684L110.054 52.7034L102.102 64.8655L111.211 76.1867L98.9491 72.8592L110.264 104.571L107.366 105.347L95.5611 74.866L89.2349 84.543L88.5196 70.0295L74.4964 66.2246L88.0785 61.0597L87.3634 46.5471L96.4721 57.8684Z",
    fill: "#6C7DE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.779 72.25L117.116 73.2865H118.205L117.324 73.9271L117.66 74.9635L116.779 74.3229L115.897 74.9635L116.234 73.9271L115.352 73.2865H116.442L116.779 72.25Z",
    fill: "#46F7B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.839 82.25L117.176 83.2865H118.266L117.384 83.9271L117.721 84.9635L116.839 84.3229L115.958 84.9635L116.295 83.9271L115.413 83.2865H116.503L116.839 82.25Z",
    fill: "url(#paint0_linear_29692_56960)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.8395 93.25L82.1762 94.2865H83.2661L82.3844 94.9271L82.7212 95.9635L81.8395 95.3229L80.9578 95.9635L81.2946 94.9271L80.4129 94.2865H81.5027L81.8395 93.25Z",
    fill: "#46F7B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.8395 103.25L78.1762 104.286H79.2661L78.3844 104.927L78.7212 105.964L77.8395 105.323L76.9578 105.964L77.2946 104.927L76.4129 104.286H77.5027L77.8395 103.25Z",
    fill: "url(#paint1_linear_29692_56960)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.839 39.25L103.176 40.2865H104.266L103.384 40.9271L103.721 41.9635L102.839 41.3229L101.958 41.9635L102.295 40.9271L101.413 40.2865H102.503L102.839 39.25Z",
    fill: "url(#paint2_linear_29692_56960)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.8395 43.25L88.1762 44.2865H89.2661L88.3844 44.9271L88.7212 45.9635L87.8395 45.3229L86.9578 45.9635L87.2946 44.9271L86.4129 44.2865H87.5027L87.8395 43.25Z",
    fill: "#46F7B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.7788 36.25L89.1156 37.2865H90.2054L89.3237 37.9271L89.6605 38.9635L88.7788 38.3229L87.8971 38.9635L88.2339 37.9271L87.3522 37.2865H88.442L88.7788 36.25Z",
    fill: "url(#paint3_linear_29692_56960)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.8395 51.25L65.1762 52.2865H66.2661L65.3844 52.9271L65.7212 53.9635L64.8395 53.3229L63.9578 53.9635L64.2946 52.9271L63.4129 52.2865H64.5027L64.8395 51.25Z",
    fill: "url(#paint4_linear_29692_56960)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.7788 65.25L67.1156 66.2865H68.2054L67.3237 66.9271L67.6605 67.9635L66.7788 67.3229L65.8971 67.9635L66.2339 66.9271L65.3522 66.2865H66.442L66.7788 65.25Z",
    fill: "#46F7B7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_29692_56960",
    x1: 115.613,
    y1: 84.8696,
    x2: 118.222,
    y2: 82.8986,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#876AE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6543FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_29692_56960",
    x1: 76.6132,
    y1: 105.87,
    x2: 79.2221,
    y2: 103.899,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#876AE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6543FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_29692_56960",
    x1: 101.613,
    y1: 41.8696,
    x2: 104.222,
    y2: 39.8986,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#876AE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6543FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_29692_56960",
    x1: 87.5525,
    y1: 38.8696,
    x2: 90.1615,
    y2: 36.8986,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#876AE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6543FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_29692_56960",
    x1: 63.6132,
    y1: 53.8696,
    x2: 66.2221,
    y2: 51.8986,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#876AE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6543FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_29692_56960"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 119,
    height: 119,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgNoDataPrimaryCheckingAccount);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/no_data_primary_checking_account.5218291136ac5dc05a46093061ff402c.svg";